"use strict";
// Stremio Plus: what a kids profile cannot reach.
// Content itself is filtered in plus/worker.js.
Object.defineProperty(exports, "__esModule", { value: true });
exports.isKidsBlockedPath = exports.KIDS_AGE_OPTIONS = exports.KIDS_BLOCKED_ROUTES = void 0;
exports.KIDS_BLOCKED_ROUTES = ['/addons', '/settings'];
exports.KIDS_AGE_OPTIONS = [6, 10, 12, 16];
var isKidsBlockedPath = function (pathname) {
    return exports.KIDS_BLOCKED_ROUTES.some(function (route) { return pathname === route || pathname.startsWith("".concat(route, "/")); });
};
exports.isKidsBlockedPath = isKidsBlockedPath;
